


































































































































import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import {MixinMember} from '@/components/mixins/MixinMember'
import {Period} from '@/enums/Period'
import CockpitRequest from '@/model/request/CockpitRequest'
import * as Helper from '@/helpers'
import {getResponsavel, ItrackCollection} from '@/helpers'
import {Collection, ID, IResource, ObjectCollection} from 'simpli-web-sdk'
import Carga from '@/model/resource/Carga'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'
import {GroupBy} from '@/enums/GroupBy'

@Component
export default class FilterCockpit extends Mixins(MixinMember) {
  @Prop({required: true}) value!: CockpitRequest
  @Prop({type: Boolean}) blockDate?: boolean

  Period = Period

  model = new Carga()
  collection = new Collection(Carga)

  async mounted() {
    await this.value.allCentroDeCusto.query()
    await this.value.allTipoOcorrencia.query()
    await this.value.allTipoInsumo.query()

    const filterNaoDevolvida = this.value.allTipoOcorrencia.items.filter((item) =>
            // @ts-ignore
        item.responsavel.$id === getResponsavel().$id || !item.responsavel.$id)

    this.value.tipoOcorrenciaNaoDevolvidaCollection = Helper.collect(TipoOcorrencia, filterNaoDevolvida)
  }

  @Watch('value.updateAutomatically')
  updateAutomaticallyEvent(val: boolean) {
    Helper.setUpdateAutomaticallyCockpit(val)
  }

  formatSigla() {
    if (this.value.sigla) {
      this.value.sigla = this.value.sigla.toUpperCase()
    }
  }

  memberRespEvent(id: ID) {
      this.value.idRespFiltroFilial = id
  }
}
